










































































































































































































































































import {Component, Prop, Vue} from "vue-property-decorator";
import Formulario from "@/components/Formulario.vue";
import info from "@/info";

@Component({
  components: {
    Formulario,
  },
})
export default class CotizadorMovil extends Vue {
  public autoName: string = "";
  public aIndex: object = {};
  public homeInfo: Array<object> = [];

  public inactiveSliderI: number = 0;
  public focusTittleI: number = 0;
  
  public clickedModel: string = "";
  public currentModel: string = "";

  public engPercent: number = 55;
  public engTotal: number = 0;
  public engTotalFixed: string = "";
  public plazTotal: number = 72;
  public plazTotalIndex: number = 0;
  public mensTotal: number = 0;
  public mensTotalFixed: string = "";
  public mensMin: number = 1;
  public mensMinFixed: string = "";
  public mensMax: number = 10;
  public mensMaxFixed: string = "";
  public priceTotal: number= 0;
  public interesT: number = 0;
  public seguroAuto: number = 0;
  public seguroAutoFixed: string = "";
  public contadoIVA: number = 0;
  public constIVA: number = 0;
  public financiadoIVA: number = 0;
  public IVAF: number = 0;
  public IVAFixed: string = "";
  public ivaIndex: number = 0;
  public pagoIniT: number = 0;
  public pagoIniTFixed: string = ""; 
  public pagoMensT: number = 0; /*-- new --*/
  public pagoMensTFixed: string = ""; /*-- new --*/

  mounted() {
      this.homeInfo = info.home.headerSlider;
      this.autoName = this.$route.query.variableName as string;
      for (let i in info.home.headerSlider) {
          if (info.home.headerSlider[i].name === this.autoName) {
          this.aIndex = info.home.headerSlider[i];
          this.priceTotal= parseFloat(info.home.headerSlider[i].price.replace(",", ""));
          }
      }
      this.engTotal = (this.engPercent/100)*this.priceTotal;
      this.engTotalFixed = new Intl.NumberFormat('es-MX', { minimumFractionDigits: 2 }).format(this.engTotal);
      setTimeout(function(){
        document.getElementById("btnTiket")!.click();
      }, 500);
  }
  
  public circularBTNS1() {
    this.inactiveSliderI = 0;
    let circleBTN = document.getElementById("circleBTNIMG");
    circleBTN!.style.transform = "rotate(-120deg)"; 
    this.focusTittleI = 0;
  }

  public circularBTNS2() {
    this.inactiveSliderI = 1;
    let circleBTN = document.getElementById("circleBTNIMG");
    circleBTN!.style.transform = "rotate(0deg)"; 
    this.focusTittleI = 1;
  }
  
  public circularBTNS3() {
    this.inactiveSliderI = 2;
    let circleBTN = document.getElementById("circleBTNIMG");
    circleBTN!.style.transform = "rotate(120deg)"; 
    this.focusTittleI = 2;
  }


public rangesSliderEng() {
  const sliderEl = document.querySelector("#rangeSEng");
  const sliderEl11 = document.querySelector("#rangeSEng1");
  const sliderEl2 = document.querySelector("#rangeSMens");
  const sliderEl22 = document.querySelector("#rangeSMens1");
  const rangePlazoM1 = document.querySelector("#rangePlazoM1");

  sliderEl2!.addEventListener("input", (event2) => {
    let tempSliderValue2 = (event2.target as HTMLInputElement).value;
    this.mensTotal = Number(tempSliderValue2)
    
    const progress2 = ((Number(tempSliderValue2)-Number((sliderEl2 as HTMLInputElement).min))/(Number((sliderEl2 as HTMLInputElement).max)-Number((sliderEl2 as HTMLInputElement).min)))*100;
    this.engPercent  = Math.round((((100 - progress2)/ 100) * (85 - 20)) + 20);

    this.operationsForm()
  })

  sliderEl22!.addEventListener("input", (event2) => {
    let tempSliderValue22 = (event2.target as HTMLInputElement).value;
    this.mensTotal = Number(tempSliderValue22)
    
    const progress22 = ((Number(tempSliderValue22)-Number((sliderEl22 as HTMLInputElement).min))/(Number((sliderEl22 as HTMLInputElement).max)-Number((sliderEl22 as HTMLInputElement).min)))*100;
    this.engPercent  = Math.round((((100 - progress22)/ 100) * (85 - 20)) + 20);

    this.operationsForm()
  })

  sliderEl!.addEventListener("input", (event) => {
    let tempSliderValue = (event.target as HTMLInputElement).value;
    this.engPercent = Number(tempSliderValue)
    this.operationsForm()
  })
  sliderEl11!.addEventListener("input", (event) => {
    let tempSliderValue11 = (event.target as HTMLInputElement).value;
    this.engPercent = Number(tempSliderValue11)
    this.operationsForm()
  })

  rangePlazoM1!.addEventListener("input", (event) => {
    let tempSliderValue112 = (event.target as HTMLInputElement).value;
    this.plazTotalIndex = Number(tempSliderValue112)
    this.plazTotal = 12 * (this.plazTotalIndex+1);
    this.operationsForm()
  })
}

public setRadioP(value: string) {
    document.querySelectorAll(`input[name="pazos"]`).forEach(element => {
        if((element as HTMLInputElement).value === value) {
          (element as HTMLInputElement).checked = true;
        }
    });
}

public RadioP() {
    document.querySelectorAll(`input[name="pazos"]`).forEach(element => {
        if((element as HTMLInputElement).checked === true) {
          this.plazTotalIndex = Number((element as HTMLInputElement).value);
          this.plazTotal = 12 * (this.plazTotalIndex+1);
          this.operationsForm();
        }
    });
}

public radioIVA() {
  document.querySelectorAll(`input[name="seguro"]`).forEach(element => {
      if((element as HTMLInputElement).checked === true) {
        if((element as HTMLInputElement).value === "0") {
          this.ivaIndex = 0;
        }
        if((element as HTMLInputElement).value === "1") {
          this.ivaIndex = 1;
        }
        this.operationsForm();
      }
  });
}
operationsForm(): void {
  this.engTotal = (this.engPercent/100)*this.priceTotal;
  this.engTotalFixed = new Intl.NumberFormat('es-MX', { minimumFractionDigits: 2 }).format(this.engTotal);

  const interestRates = [6.87, 13.54, 20.52, 27.82, 35.43, 43.33];
  const interestCoefficients = [0.085, 0.17, 0.25, 0.35, 0.45, 0.54];

  this.interesT = interestRates[this.plazTotalIndex] - ((this.engPercent - 20) * interestCoefficients[this.plazTotalIndex]);

  this.mensMin = ((((this.priceTotal * (interestRates[this.plazTotalIndex] - ((20 - 20) * interestCoefficients[this.plazTotalIndex])))/100) + this.priceTotal) - (0.20 * this.priceTotal)) / this.plazTotal;
  this.mensMinFixed = new Intl.NumberFormat('es-MX', { minimumFractionDigits: 2 }).format(this.mensMin);
  
  this.mensMax = ((((this.priceTotal * (interestRates[this.plazTotalIndex] - ((85 - 20) * interestCoefficients[this.plazTotalIndex])))/100) + this.priceTotal) - (0.85 * this.priceTotal)) / this.plazTotal;
  this.mensMaxFixed = new Intl.NumberFormat('es-MX', { minimumFractionDigits: 2 }).format(this.mensMax);

  this.mensTotal = ((((this.priceTotal*this.interesT)/100)+this.priceTotal) - this.engTotal)/this.plazTotal;
  this.mensTotalFixed = new Intl.NumberFormat('es-MX', { minimumFractionDigits: 2 }).format(this.mensTotal);

  if(this.ivaIndex === 0) {
    this.IVAF = this.contadoIVA - (this.constIVA * (this.engPercent-20));
    this.IVAFixed = new Intl.NumberFormat('es-MX', { minimumFractionDigits: 2 }).format(this.IVAF);
  }
  if(this.ivaIndex === 1) {
    this.IVAF = (this.contadoIVA - (this.constIVA * (this.engPercent-20))) + this.financiadoIVA;
    this.IVAFixed = new Intl.NumberFormat('es-MX', { minimumFractionDigits: 2 }).format(this.IVAF);
  }

  this.pagoIniT = this.engTotal +  this.IVAF; /*-- ajustado --*/	
  this.pagoMensT = this.mensTotal + (this.IVAF/12);
  if(this.ivaIndex === 0) {
    this.pagoIniT = this.pagoIniT + this.seguroAuto;
  }
  if(this.ivaIndex === 1) {
    this.pagoMensT = this.pagoMensT + (this.seguroAuto/12);
  }
  this.pagoMensTFixed = new Intl.NumberFormat('es-MX', { minimumFractionDigits: 2 }).format(this.pagoMensT);
  this.pagoIniTFixed = new Intl.NumberFormat('es-MX', { minimumFractionDigits: 2 }).format(this.pagoIniT); /*-- ajustado --*/

  const sliderEl2 = document.querySelector("#rangeSMens");

  (sliderEl2 as HTMLInputElement).min = String(this.mensMax);
  (sliderEl2 as HTMLInputElement).max = String(this.mensMin);
  (sliderEl2 as HTMLInputElement).value = String(this.mensTotal);
  const progress2 = ((this.mensTotal-Number((sliderEl2 as HTMLInputElement).min))/(Number((sliderEl2 as HTMLInputElement).max)-Number((sliderEl2 as HTMLInputElement).min)))*100;
  (sliderEl2 as HTMLInputElement).style.background = `linear-gradient(to right, #017fff ${progress2}%, #ccc 0%)`;

  const sliderEl22 = document.querySelector("#rangeSMens1");

  (sliderEl22 as HTMLInputElement).min = String(this.mensMax);
  (sliderEl22 as HTMLInputElement).max = String(this.mensMin);
  (sliderEl22 as HTMLInputElement).value = String(this.mensTotal);

  const sliderEl = document.querySelector("#rangeSEng");
  const progress = ((this.engPercent-Number((sliderEl as HTMLInputElement).min))/(Number((sliderEl as HTMLInputElement).max)-Number((sliderEl as HTMLInputElement).min)))*100;
  (sliderEl as HTMLInputElement).style.background = `linear-gradient(to right, #017fff ${progress}%, #ccc 0%)`;
  (sliderEl as HTMLInputElement).value = String(this.engPercent);

  const sliderEl11 = document.querySelector("#rangeSEng1");
  (sliderEl11 as HTMLInputElement).value = String(this.engPercent);

  const rangePlazoM1 = document.querySelector("#rangePlazoM1");
  (rangePlazoM1 as HTMLInputElement).value = String(this.plazTotalIndex);
}
openMenuForm2(auto: string, i: object, sA: number, IVA: number, constIVA: number, fIVA: number,  p: string ): void {

  this.clickedModel = auto;
  this.aIndex = i;
  this.seguroAuto = sA;
  this.seguroAutoFixed = new Intl.NumberFormat('es-MX', { minimumFractionDigits: 2 }).format(this.seguroAuto);
  this.contadoIVA = IVA;
  this.constIVA = constIVA;
  this.financiadoIVA = fIVA;


  const idDivModel = document.getElementById("uk-navbar-dropdown-id-ml");
  const idDiv = document.getElementById("uk-navbar-dropdown-id");

  if (idDivModel) {
      idDivModel.style.display = "none";}
  if (idDiv) {
    idDiv.style.display =  "none";}


  let curtainForm = document.getElementById("curtain-formH2");
  let menuForm = document.getElementById("menu-formH2");

  if (curtainForm) {
    curtainForm.style.display = "block";
  }
  menuForm?.classList.remove("disable-menu-formH2");
  menuForm?.classList.add("open-menu-formH2");

  this.IVAF = this.contadoIVA - (this.constIVA * (this.engPercent-20));
  this.IVAFixed = new Intl.NumberFormat('es-MX', { minimumFractionDigits: 2 }).format(this.IVAF);

  const sliderEl2 = document.querySelector("#rangeSMens");

  (sliderEl2 as HTMLInputElement).min = String(this.mensMax);
  (sliderEl2 as HTMLInputElement).max = String(this.mensMin);


  this.rangesSliderEng();
  this.setRadioP(String(this.plazTotalIndex));
  this.operationsForm();
}
closeMenuForm2() {

  let curtainForm = document.getElementById("curtain-formH2");
  let menuForm = document.getElementById("menu-formH2");

  if (curtainForm) {
    curtainForm.style.display = "none";
  }
  menuForm?.classList.remove("open-menu-formH2");
  menuForm?.classList.add("disable-menu-formH2");
}

openMenuForm21(): void {
  this.closeMenuForm2();


  let curtainForm = document.getElementById("curtain-formH2-1");
  let menuForm = document.getElementById("menu-formH2-1");

  if (curtainForm) {
    curtainForm.style.display = "block";
  }
  menuForm?.classList.remove("disable-menu-formH2-1");
  menuForm?.classList.add("open-menu-formH2-1");

}
closeMenuForm21() {

  let curtainForm = document.getElementById("curtain-formH2-1");
  let menuForm = document.getElementById("menu-formH2-1");

  if (curtainForm) {
    curtainForm.style.display = "none";
  }
  menuForm?.classList.remove("open-menu-formH2-1");
  menuForm?.classList.add("disable-menu-formH2-1");
}

openMenuFormF(): void {


  const idDivModel = document.getElementById("uk-navbar-dropdown-id-ml");
  const idDiv = document.getElementById("uk-navbar-dropdown-id");

  if (idDivModel) {
      idDivModel.style.display = "none";}
  if (idDiv) {
    idDiv.style.display =  "none";}


  let curtainForm = document.getElementById("curtain-formHF");
  let menuForm = document.getElementById("menu-formHF");

  if (curtainForm) {
    curtainForm.style.display = "block";
  }
  menuForm?.classList.remove("disable-menu-formHF");
  menuForm?.classList.add("open-menu-formHF");

}
closeMenuFormF() {

  let curtainForm = document.getElementById("curtain-formHF");
  let menuForm = document.getElementById("menu-formHF");

  if (curtainForm) {
    curtainForm.style.display = "none";
  }
  menuForm?.classList.remove("open-menu-formHF");
  menuForm?.classList.add("disable-menu-formHF");
}

  
}

